<template>
    <button class="button" type="button">
        <slot></slot>
    </button>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

export default class BaseButton extends Vue {}
</script>

<style scoped></style>
